/* eslint-disable react/no-unknown-property */
/* eslint-disable prettier/prettier */
/** @jsx jsx */

import { Box, jsx, Text, Container } from 'theme-ui';
// import NewSolarSystem from './NewSolarSystem';
// import NewSolarSystem from './NewSolarSystem';
import Rings from './Rings';
// import SolarSystem from './SolarSystem';

function Hero() {
  return (
    <Container
      // variant="styles.plateHero"
      sx={{
        minHeight: [`70vh`, `73vh`, `73vh`],
        borderBottomColor: `grays.4`,
        maxWidth: [`90vw`, `80vw`, `93vw`],
        marginLeft: [`auto`, `auto`, `auto`],
        marginRight: [`0px`, `0px`, `0px`],
        px: [0, 4, 0],
        pt: [0, 0, 7],
        display: `flex`,
        alignItems: `center`,
        justifyContent: `space-between`,
        flexWrap: `wrap`,
        overflow: `hidden`,
      }}
    >
      <Box
        sx={{
          // maxWidth: [`90vw`, `30ch`, `100ch`],
          flex: `0.5`,
          // py: [`20vh`, 7, 0],
          // '@media screen and (max-width: 720px)': {
          //   position: `absolute`,
          //   top: 0,
          // },
        }}
      >
        <Text as="h1" variant="heroTitle" sx={{ marginBottom: `32px` }}>
          Launch incredible products
        </Text>
        <Box>
          <Text
            as="h2"
            variant="heroDesc"
            sx={{ color: `Stext`, lineHeight: `body` }}
          >
            We provide design and tech infrastructure to your ideas
          </Text>
        </Box>
      </Box>
      <Box
        sx={{
          flex: [`0.7`],
          overflow: `hidden`,
          height: `73vh`,
          position: [`absolute`, `relative`, `relative`],
          maxWidth: `69vw`,
          marginLeft: [`80px`, 0, 0],
          // '@media screen and (max-width: 720px)': {
          //   position: `absolute`,
          //   top: `-2vh`,
          // },
        }}
      >
        <Rings />
      </Box>
    </Container>
  );
}

export default Hero;
